var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Link } from '@paypalcorp/pp-react';
import { getCoBrand } from '../utils';
import config from './config';
import './style.css';
export default function ({ countryCode = 'US', language = 'en', logger }) {
    const [footerTexts, setFooterTexts] = useState({});
    const coBrand = getCoBrand(countryCode);
    useEffect(() => {
        const filterFooterTexts = (footerTexts) => {
            // The list of footer links needs to be in a specific order
            const footerLinksOrderedList = ['home', 'about', 'contact', 'privacy', 'legal', 'imprint', 'policy', 'worldwide'];
            const updatedFooterTexts = {};
            for (let text of footerLinksOrderedList) {
                if (config.showLinks[text].countries.includes(countryCode)) {
                    updatedFooterTexts[text] = footerTexts[text];
                }
            }
            setFooterTexts(updatedFooterTexts);
        };
        const fetchFooterTexts = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const content = yield fetch(`https://www.paypalobjects.com/iwc/${countryCode}/${language}/footer.json`);
                if (content.ok) {
                    content.json().then((data) => {
                        filterFooterTexts(data);
                    });
                }
            }
            catch (err) {
                console.log(err);
            }
        });
        fetchFooterTexts();
    }, [countryCode, language]);
    // Contact Us Privacy Legal Policy Updates Worldwide
    return (React.createElement("footer", { className: "footer" },
        React.createElement("ul", null, Object.entries(footerTexts).map(([term, text], idx) => {
            return (React.createElement("li", { key: idx },
                React.createElement(Link, { size: "sm", style: { color: 'gray', fontSize: '11px', fontWeight: 'bold' }, href: `/${coBrand}${config.links[term]}`, key: text, target: "blank", onClick: () => {
                        logger.track('footer_link_clicked'); // TODO send value for the clicked linked once dynamic instrumentation is available
                    } }, text)));
        }))));
}
